import React from 'react';
import husqvarnaPlaceholder from '../../styles/images/logo-husqvarna.svg';
import salewaPlaceholder from '../../styles/images/logo-salewa.svg';
import nordeaPlaceholder from '../../styles/images/logo-nordea.svg';
import kreditzPlaceholder from '../../styles/images/logo-kreditz.svg';
import laserPlaceholder from '../../styles/images/logo-laser.svg';
import melkerPlaceholder from '../../styles/images/logo-melker.png';
import { Translate } from "react-redux-i18n";

export default function Partners() {
    return (
        <section className="gray-bg">
          <div className="main-container partner-container">
              <div className="content-wrapper">
                <h1><Translate value="menu.partners"/></h1>
                <div className="partners-logos-wrapper">
                    <img src={husqvarnaPlaceholder} alt="Husqvarna Partners"/>
                    <img src={salewaPlaceholder} alt="Salewa Partners"/>
                    <img src={nordeaPlaceholder} alt="Nordea Partners"/>
                    <img src={melkerPlaceholder} alt="Melker Partners" width="166"/>
                    <img src={laserPlaceholder} alt="Laser Partners"/>
                    <img src={kreditzPlaceholder} alt="Kreditz Partners"/>
                </div>
                <a href="https://blog.ihopa.com/ihopa-for-businesses/" target="_blank" rel="noopener noreferrer" className="partner-link bp3-button bp3-intent-primary cta secondary-color" id="start-co-owning"><Translate value="menu.ihopa_for_business"/></a>
              </div>
            </div>
        </section>
    )
}
